import EnhancedContactForm from '@components/forms/enhanced';
import FormRealtorCards from '@components/forms/enhanced/realtor-cards';
import BrokerReciprocityCard from '@components/broker-reciprocity-card';
import { useListingContext } from '../../context';

const PropertySidebar = ({ setRequestATourModalIsOpen }) => {
  const {
    shouldShowSibcyAgent,
    primaryDisplayAgent,
    secondaryDisplayAgent,
    associatedAgent,
    hasTour,
    hasSecondaryAgent,
    informationRequestDefaultComments,
    listingId: id
  } = useListingContext();

  return (
    <>
      {shouldShowSibcyAgent ? (
        <EnhancedContactForm
          defaultFormValue={informationRequestDefaultComments}
          primaryAgent={primaryDisplayAgent}
          secondaryAgent={secondaryDisplayAgent}
          hasTour={hasTour}
          hasSecondaryAgent={hasSecondaryAgent}
          listingId={id}
          agentId="0"
          sticky={true}
          setModalIsOpen={setRequestATourModalIsOpen}
          endpoint="property information request"
        >
          <FormRealtorCards
            hasTour={hasTour}
            hasSecondaryAgent={hasSecondaryAgent}
            setModalIsOpen={setRequestATourModalIsOpen}
            primaryContact={primaryDisplayAgent}
            secondaryContact={secondaryDisplayAgent}
          />
        </EnhancedContactForm>
      ) : !associatedAgent ? (
        <BrokerReciprocityCard
          hasTour={hasTour}
          listingId={id}
          defaultFormValue={informationRequestDefaultComments}
          sticky={true}
          setModalIsOpen={setRequestATourModalIsOpen}
        />
      ) : (
        <EnhancedContactForm
          hasTour={hasTour}
          setModalIsOpen={setRequestATourModalIsOpen}
          primaryAgent={primaryDisplayAgent || associatedAgent}
          secondaryAgent={secondaryDisplayAgent}
          sticky={true}
          listingId={id}
          agentId={associatedAgent.agentId}
          defaultFormValue={informationRequestDefaultComments}
          endpoint="property information request"
        >
          <FormRealtorCards
            hasTour={hasTour}
            setModalIsOpen={setRequestATourModalIsOpen}
            primaryContact={associatedAgent}
          />
        </EnhancedContactForm>
      )}
    </>
  );
};

export default PropertySidebar;
